<template>
  <main>
    <b-container
      fluid
      class="mt-4 p-4 border"
      v-if="$helper.verificaPermissao('visualizar_submenu_eixos_subeixos')"
    >
      <b-row class="mb-4">
        <b-col class="md-6">
          <h4 class="mb-0">Eixos</h4>
        </b-col>
        <b-col class="md-6">
          <b-button
            @click="showNovo"
            v-b-modal.modal-1
            :disabled="isLoading"
            variant="outline-primary"
            class="ml-1 float-right"
            >Cadastrar
          </b-button>
        </b-col>
      </b-row>
      <b-overlay :show="isLoading" rounded="sm">
        <div class="table-responsive">
          <table class="table table-hover table-sm">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Descrição</th>
                <th scope="col" class="col-2">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="eixo in eixos" :key="eixo.id">
                <td>{{ eixo.id }}</td>
                <td>{{ eixo.descricao }}</td>
                <td>
                  <div class="d-flex align-items-center">
                    <button
                      @click="showEditar(eixo)"
                      v-b-modal.modal-1
                      v-b-tooltip.hover
                      title="Editar"
                      class="btn btn-primary btn-sm"
                    >
                      <b-icon icon="pencil"></b-icon>
                    </button>
                    <button
                      v-b-tooltip.hover
                      title="Excluir eixo"
                      @click="excluirEixo(eixo)"
                      class="btn btn-danger btn-sm ml-2"
                    >
                      <b-icon icon="trash"></b-icon>
                    </button>
                    <button
                      v-b-tooltip.hover
                      title="Ver subeixos"
                      @click="$router.push(`/eixos/${eixo.id}`)"
                      class="btn btn-warning btn-sm ml-2"
                    >
                      <b-icon icon="arrow-right"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-overlay>

      <b-modal
        id="modal-1"
        title="Novo Eixo"
        :hide-footer="true"
        title-class="font-weight-bold"
      >
        <b-form>
          <div class="row">
            <div class="col-lg-6">
              <b-form-group
                label="Descrição: *"
                label-class="font-weight-bolder"
              >
                <b-form-input
                  v-model="descricao"
                  required
                  placeholder="Digite uma descrição..."
                ></b-form-input>
                <form-error
                  v-if="validationErrors.descricao"
                  :error="['O campo descrição é obrigatório']"
                />
              </b-form-group>
            </div>
            <div class="col-12">
              <hr />
              <b-button
                :disabled="isLoading"
                @click="editar ? editarCategoria() : addEixo()"
                variant="primary"
                class="float-right"
                >{{ editar ? 'Editar' : 'Salvar' }}</b-button
              >
            </div>
          </div>
        </b-form>
      </b-modal>
    </b-container>
    <h1 v-else>Seu perfil não tem permissão para acessar este conteúdo</h1>
  </main>
</template>

<script>
import FormError from '@/components/FormError';

export default {
  components: { FormError },
  data() {
    return {
      eixo: {},
      eixos: [],
      isLoading: false,
      descricao: '',
      validationErrors: {
        descricao: null,
      },
      editar: false,
    };
  },
  methods: {
    addEixo() {
      this.editar = false;

      let data = {
        descricao: this.descricao,
      };
      this.isLoading = true;
      this.$http
        .post('eixos', data, {})
        .then(res => {
          this.$swal({
            title: 'Eixo cadastrado com sucesso!',
            icon: 'success',
          });
          this.eixos.push(res.data);
          this.clear();
          this.isLoading = false;
          this.$bvModal.hide('modal-1');
        })
        .catch(error => {
          this.validationErrors.descricao = error.response.data.descricao
            ? error.response.data.descricao
            : null;
          console.error(error.response.data);
          this.isLoading = false;
        });
    },
    getEixos() {
      this.isLoading = true;
      this.$http
        .get('eixos', {})
        .then(res => {
          this.eixos = res.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.error(error.response.data);
          this.isLoading = false;
        });
    },
    showNovo() {
      this.titulo = 'Novo Eixo';
      this.editar = false;

      this.descricao = '';
    },
    showEditar(eixo) {
      this.titulo = 'Editar Eixo';
      this.editar = true;

      this.eixo = eixo;
      this.descricao = eixo.descricao;
    },
    editarCategoria() {
      let data = {
        descricao: this.descricao,
      };
      this.isLoading = true;
      this.$http
        .put(`eixos/${this.eixo.id}`, data, {})
        .then(res => {
          this.$swal({ title: 'Eixo editado com sucesso!', icon: 'success' });
          this.eixos = this.eixos.map(eixo =>
            eixo.id === res.data.id ? res.data : eixo
          );
          this.isLoading = false;
          this.$bvModal.hide('modal-1');
        })
        .catch(error => {
          console.error(error.response.data);
          this.isLoading = false;
        });
    },
    excluirEixo(eixo) {
      this.$swal({
        icon: 'warning',
        title: 'Tem certeza que deseja excluir esse eixo?',
        showDenyButton: true,
        confirmButtonText: 'Sim',
        confirmButtonColor: '#3085d6',
        denyButtonText: 'Cancelar',
      })
        .then(result => {
          this.isLoading = true;
          if (result.isConfirmed) {
            this.$http.delete(`eixos/${eixo.id}`, {});
            this.$swal('Eixo removido com sucesso!', '', 'success');
            this.eixos = this.eixos.filter(elem => elem.id !== eixo.id);
          } else if (result.isDenied) {
            this.$swal('Uffa! Foi por pouco.', '', 'warning');
          }
          this.isLoading = false;
        })
        .catch(error => {
          console.error(error.response.data);
          this.isLoading = false;
        });
    },
    clear() {
      this.eixo = {};
      this.descricao = '';
      this.validationErrors.descricao = '';
    },
  },
  created() {
    this.getEixos();
  },
  beforeCreate() {
    //Check if profile is SDC, if not, redirect to home.
    if (JSON.parse(localStorage.getItem('user')).perfil.grupo_perfil_id != '1') {
      this.$router.push('/processos/minha-unidade');
    }
  },
};
</script>

<style scoped>
td,
th {
  vertical-align: middle !important;
}
</style>
